module.exports = __webpack_public_path__ + "static/treppe-cfdc959889e1e87670f97da441e615fe.jpg";